module.exports = __webpack_public_path__ + "img/wheel1.4c658211.gif";